import User from './user'
class Complex{

  constructor(id,status,name,address,description,lat,lng,invoice,owner,city, country, state,currency,price,playerSubscriptions){
    this.country = country || ""
    this.city = city || ""
    this.state = state || ""
    this.id = id
    this.status = status || "inactive"
    this.name = name || ""
    this.address = address || ""
    this.description = description || ""
    this.lat = lat || 0
    this.lng = lng || 0
    this.invoice = invoice || {name: "", rfc: "",
    postal_code: "", neigborhood: "",city: "", state: "", street: "",
    number: "", internal: ""}
    this.owner = owner || new User()
    this.currency = currency || "MXN"
    this.price = price || 0.0
    this.playerSubscriptions = playerSubscriptions || false

  }


  static parse(responseData){
    if(!responseData){return new Complex()}
    let d = responseData
    return new Complex(d.id,d.status,d.name,d.address,d.description,d.lat,d.lng,d.invoice,User.parse(d.owner),d.city, d.country, d.state, d.currency,d.price,d.players_subscription)
  }
}


export default Complex



// WEBPACK FOOTER //
// ./src/models/complex.js